<div class="document-modal">
  @if (data?.text?.trim()) {
    <pa-info-block>
      <div class="date-content" [innerHTML]="data.text"></div>
    </pa-info-block>
  }

  @if (data?.files?.length) {
    <pa-info-block blockTitle="Прикреплённые файлы" [isToggleVisible]="true">
      <pa-data-list [data]="fileListData"></pa-data-list>
    </pa-info-block>
  }
</div>